((app) => {
    //
    // Md-dialog's "this" refers to the window instead of the an
    // isolated scope. So we'll set $ctrl to an empty object instead 
    // to keep the template naming convention intact.
    //
    app.controller("fileUploadCtrl", ["$scope", "$mdDialog", "fileUploadApi", "$q", "processorTrackApi", 
    ($scope, $mdDialog, fileUploadApi, $q, processorTrackApi) => {
        let $ctrl = {};
        $scope.$ctrl = $ctrl;
        $ctrl.uploadedFiles = [];
        $ctrl.ui = { loading: false };

        $ctrl.$onInit = async () => {
            try {
                $ctrl.tracks = await processorTrackApi.getMappedTracks();
            } catch(err) {
                // toast
                console.error(err);
            }
        };
        $ctrl.$onInit();

        $ctrl.close = () => {
            $mdDialog.cancel();
        };

        $ctrl.upload = (files, trackId) => {
            $ctrl.ui.loading = true;
            let promises = [];
            files.forEach(file => {
                let formData = new FormData();
                formData.append("Content", file, file.name);
                promises.push(fileUploadApi.uploadFile(formData, trackId));
            });
            $q.all(promises)
                .finally(() => {
                    $ctrl.ui.loading = false;
                });
        };
        
        //
        // Returns a comma separated list of all of the file names.
        //
        $ctrl.uploadedFileNames = (files) => {
            if(files) {
                files.forEach((file) => {
                    $ctrl.uploadedFiles.push(file);
                });
            } 
            return $ctrl.uploadedFiles.map((file) => {
                return file.name;
            }).join(", ");
        };

        //
        // To keep a list of uplaoded files we'll watch the attached model
        //
        $scope.$watch("$ctrl.files", (files) => {
            $ctrl.uploadedFileNames(files);
        });
    }]);
})(window.app);
